<kt-base-modal [title]="'Start Loop (' + selectedLoop?.loop_name + ')'">

  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div #wizard class="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1">
        <!--begin: Form Wizard Nav -->
        <div class="kt-grid__item kt-wizard-v1__nav-items--clickable">
          <div class="kt-wizard-v1__nav">
            <div class="kt-wizard-v1__nav-items">

              <div class="kt-wizard-v1__nav-item " data-ktwizard-type="step" data-ktwizard-state="done">
                <div class="kt-wizard-v1__nav-body">
                  <div class="kt-wizard-v1__nav-label">
                    1. Select Loop
                  </div>
                </div>
              </div>
              <div class="kt-wizard-v1__nav-item " data-ktwizard-type="step" data-ktwizard-state="current">
                <div class="kt-wizard-v1__nav-body">

                  <div class="kt-wizard-v1__nav-label">
                    2. Verify
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Form Wizard Nav -->

        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <!--begin: Form Wizard Form-->
          <div class="kt-form" id="kt_form">
            <form>
              <div class="body-scroll">
                <!--begin: Form Wizard Step 1 (client)-->
                <div class="kt-wizard-v1__content " data-ktwizard-type="step-content" data-ktwizard-state="current">

                  <div>
                    <div style="min-height: 400px;">
                      <div class="m-1 p-3 h5 text-center ">
                        Select Loop
                      </div>
                      <div class="kt-notification">
                        <ng-container *ngFor="let loop of loops">
                          <div class="kt-widget__head">

                            <div class="kt-widget__content">
                              <div class="kt-widget__section">
                                <label class="kt-option">
                                  <span class="kt-option__control">
                                    <span class="kt-radio kt-radio--brand">
                                      <input type="radio" [(ngModel)]="selectedLoop" name="loop" [value]="loop">
                                      <span></span>
                                    </span>
                                  </span>
                                  <span class="kt-option__label">
                                    <span class="kt-option__head">
                                      <span class="kt-option__title">
                                        {{loop.loop_name}}
                                      </span>
                                      <span *ngIf="loop?.actual_loop?.length"
                                        class="float-end kt-link kt-link--brand ">
                                        Filled {{loop?.actual_loop?.length}}/{{loop?.loop_multiple_count}} Times
                                      </span>
                                      <a class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                        (click)="loopViewclickHandler(loop)" href="javascript:;">
                                        <svg-icon class=" d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/view.svg"></svg-icon>
                                      </a>
                                    </span>
                                  </span>
                                </label>

                              </div>
                            </div>
                          </div>
                          <div *ngIf="selectedLoop === loop">
                            <ng-container *ngFor="let actulaLoop of loop.actual_loop">
                              <div class="ms-5 ps-5">
                                <b>Filled At:-</b> {{actulaLoop.timesheet_log_created_at | TimezoneDateTime}}
                                <a class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                  (click)="loopViewclickHandler(loop, actulaLoop)" href="javascript:;">
                                  <svg-icon class=" d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/view.svg"></svg-icon>
                                </a>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>

                    </div>
                  </div>
                </div>
                <!--end: Form Wizard Step 1-->
                <!--begin: Form Wizard Step 1 (client)-->
                <div class="kt-wizard-v1__content mt-3" data-ktwizard-type="step-content" data-ktwizard-state="current">

                  <google-map *ngIf="mapReady() && location.latitude" class="kt-map d-block w-100" width="100%"
                    height="400px" [center]="{ lat: location.latitude, lng: location.longitude }" [zoom]="18"
                    [options]="{ streetViewControl: false }">
                    <map-marker #m1="mapMarker" [position]="{ lat: location.latitude, lng: location.longitude }"
                      [options]="{ draggable: false, icon: defaultEnum.LOCATION_ICON_URL, title: 'My Current Location' }"
                      (mapClick)="openInfoWindow(m1, 'My Current Location')">
                    </map-marker>
                    <map-marker #m2="mapMarker" *ngIf="shiftInfo"
                      [position]="{ lat: (+shiftInfo.area.area_latitude), lng: (+shiftInfo.area.area_longitude) }"
                      [options]="{ draggable: false }"
                      (mapClick)="openInfoWindow(m2, (shiftInfo?.area?.area_name || '') + ' ' + (shiftInfo?.area?.area_address || ''))">
                    </map-marker>
                    <map-info-window>{{ infoContent }}</map-info-window>
                  </google-map>

                  <div class="h5 text-center bg-light p-3 my-3">
                    Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2'}} KMs
                  </div>
                </div>
                <!--end: Form Wizard Step 1-->
              </div>
            </form>
            <!--begin: Form Actions -->
            <div class="kt-form__actions">
              <button class="btn btn-outline-brand" type="button" data-ktwizard-type="action-prev">
                Previous
              </button>
              <!-- <kt-button (buttonClick)="saveClickHandler()" data-ktwizard-type="action-submit"
                [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG">
              </kt-button> -->
              <button class="btn btn-brand" type="button" data-ktwizard-type="action-next">
                Next
              </button>

              <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" *ngIf="isLastStepReached"
                (buttonClick)="saveClickHandler()">
              </kt-button>
            </div>

            <!--end: Form Actions -->
          </div>

          <!--end: Form Wizard Form-->
        </div>

      </div>
    </kt-loader>
  </div>

</kt-base-modal>